import { Component, Input, OnInit } from '@angular/core'
import { DealConfigurationQuery, DealOfferQuery } from 'generated/graphql'
import { DealOption, SelectableDealOption } from 'modules/deals/utilities/deal-types'
import { distinctUntilChanged, filter, map, pluck } from 'rxjs/operators'
import { Observable } from 'rxjs'

const influencingOptionNames = ['edition', 'paint', 'rims']

@Component({
    selector: 'mg-preview-tesla',
    templateUrl: './preview-tesla.component.html',
    styleUrls: ['./preview-tesla.component.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class PreviewTesla implements OnInit {
    @Input() deal$: Observable<DealConfigurationQuery['Deal'] | DealOfferQuery['Deal']>

    influencingOptions$: Observable<DealOption[]>
    influencingValues$: Observable<{ [optionName: string]: { id: string; label: string } }>

    ngOnInit() {
        this.influencingOptions$ = this.deal$.pipe(
            pluck<DealConfigurationQuery['Deal'] | DealOfferQuery['Deal'], DealOption[]>('options'),
            map(configurationOptions =>
                configurationOptions.filter(
                    configurationOption =>
                        influencingOptionNames.indexOf(
                            configurationOption.__typename === 'BooleanDealOption'
                                ? configurationOption.key
                                : configurationOption.name
                        ) > -1
                )
            ),
            distinctUntilChanged()
        )

        this.influencingValues$ = this.influencingOptions$.pipe(
            map(influencingOptions =>
                influencingOptions.reduce(
                    (influencingValues, influencingOption: SelectableDealOption) => ({
                        ...influencingValues,
                        [influencingOption.name]: influencingOption.selectableValues.find(
                            ({ id }) => id === influencingOption.selectedValue.id
                        ),
                    }),
                    {}
                )
            ),
            filter(influencingValues =>
                influencingOptionNames.every(
                    influencingOptionName =>
                        influencingValues.hasOwnProperty(influencingOptionName) &&
                        !!influencingValues[influencingOptionName]
                )
            ),
            distinctUntilChanged()
        )
    }
}
